import styled from 'styled-components'
import theme from 'theme_'

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 115px;
`

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 95px;
  justify-content: center;
  justify-content: space-evenly;
`

export const ErrorStatus = styled.div`
  font-family: ${theme.fonts.base};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.error};
  font-weight: 700;
`

export const WhiteLable = styled.label`
  color: ${theme.colors.white};
`
